module.exports = __webpack_public_path__ + "static/sport/bgi-swiper.20b4f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/bgi-swiper.png
// module id = lq+P
// module chunks = 0